// hooks/useProductsLoader.js
import { useEffect, useContext, useState } from "react";
import { Context } from "../index"; // путь подкорректируй под свой
import { getProducts, getWholesalePrices, getAvailableFilters } from "../http/productAPI";

export const useProductsLoader = (filtersFromURLLoaded) => {
  const { product, user } = useContext(Context);

  useEffect(() => {
    const loadProducts = async () => {
      console.log ("useEffect useProductsLoader")
      try {
      
        if (!filtersFromURLLoaded) return;    // запустить эту проверку перед прогрузкой где нужны ссылки 
        const selectedFolderFilters = product.requestBodyFilter;

        const data = await getProducts(
          product.selectedFolder.id,
          product.pagination.page,
          product.pagination.pageSize,
          selectedFolderFilters
        );

        let updatedProducts = data.products;

        if (user.viewAsManager && updatedProducts.length > 0) {

          const productIds = updatedProducts.map((p) => p.id);

          const optPrices = await getWholesalePrices(productIds);

          updatedProducts = updatedProducts.map((p) => ({
            ...p,
            optPrice: optPrices.find((w) => w.id === p.id)?.optPrice ?? 0
          }));
        }

        product.setProducts(updatedProducts);
      //  product.setFilters(data.filters);
        product.setPagination({
          page: data.page,
          pageCount: data.pageCount,
          pageSize: data.pageSize
        });

      } catch (error) {
        console.error("Ошибка при получении продуктов:", error);
      }
    };

    loadProducts();
  }, [
    filtersFromURLLoaded,
    product.selectedFolder,
    product.pagination.page,
    product.pagination.pageSize,
    product.selectedFilters,
    product.reload,
    user.viewAsManager
  ]);
};
